import styles from './profile-overview-screen.module.scss'
import { ActiveSeries } from './sections/active-series'
import React from 'react'
import { WorkoutStats } from 'src/component/profile/workout-stats/workout-stats'
import { CompletedSeries } from 'src/screen/profile/overview/sections/completed-series'
import { CompletedWorkouts } from 'src/screen/profile/overview/sections/completed-workouts'

export const ProfileOverviewScreen = (): React.ReactElement => {
  return (
    <div className={styles.container}>
      <WorkoutStats />
      <ActiveSeries />
      <CompletedSeries />
      <CompletedWorkouts />
    </div>
  )
}
